import { FC, ReactNode } from 'react';
import { Card, CardProps, Grid, Stack, Typography } from '@mui/material';
import CircleIcon from '@mui/icons-material/Circle';

export interface ILegendDefinition {
	color: string;
	title?: ReactNode;
	subtitle?: ReactNode;
}

export interface IDarkChartLegendsProps extends Omit<CardProps, 'title'> {
	legends: ILegendDefinition[];
}

export const DarkChartLegends: FC<IDarkChartLegendsProps> = ({ legends, sx, ...props }) => {
	return (
		<Card
			sx={{
				backgroundColor: 'common.black',
				color: 'common.white',
				paddingX: 4,
				paddingY: 2,
				...sx,
			}}
			variant="outlined"
			{...props}
		>
			<Grid container columns={legends.length} direction="row" alignItems="center" justifyContent="space-between">
				{legends.map(({ color, title, subtitle }, i) => {
					return (
						<Grid
							item
							xs={1}
							key={`chart-legend-${i}`}
							sx={{
								paddingX: 2,
								height: 1.0,
								borderRight: i !== legends.length - 1 ? '1px solid rgba(255, 255, 255, 0.6)' : undefined,
							}}
						>
							<Stack direction="row" alignItems="center" justifyContent="center">
								<CircleIcon sx={{ width: 16, height: 16, color, marginRight: 1.5 }} />
								<Stack direction="column">
									{title ? <Typography sx={{ fontWeight: 600 }}>{title}</Typography> : null}
									{subtitle ? (
										<Typography variant="body2" sx={{ lineHeight: 'normal' }}>
											{subtitle}
										</Typography>
									) : null}
								</Stack>
							</Stack>
						</Grid>
					);
				})}
			</Grid>
		</Card>
	);
};
